export default __webpack_public_path__ + "static/media/rapyd_logo.e8259559.png";